<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ChartEnergyEfficiency from '$lib/PageSections/Charts/ChartEnergyEfficiency/ChartEnergyEfficiency.svelte';
	import CustomerStory from '$lib/PageSections/CustomerStory/CustomerStory.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import ProductRecommendation from '$lib/PageSections/Products/ProductRecommendation.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	import { ThermalProduct } from '$lib/data/products/products-data.js';
	import { thisOldHouseCustomerStory } from '$routes/(public)/resources/case-studies/customer-stories.js';

	import archWindowInstallImage from './images/archWindowInstall.png';
	import whiteOfficeImage from './images/whiteOffice.jpg';
</script>

<Section>
	<h2 class="text-left">The Challenges Of Non-Rectangular Windows</h2>
	<p class="text-left">
		Unique windows can add so much character to a room - even acting as a work
		of art! But when it comes time to upgrade your windows, replacing or
		restoring specialty shaped windows can be very expensive and difficult to
		find.
	</p>
	<Image src={whiteOfficeImage} loading="eager" />
	<p class="text-left">
		Fortunately, there is an easier and more affordable alternative to insulate
		your specialty shaped windows - and your rectangular windows!
	</p>

	<h2 class="text-left">Custom-Crafted Windows In (Nearly) Any Shape</h2>
	<p class="text-left">
		With our patented Snug Fit compression tubing and premium acrylic glazing,
		our <a href="/products/indowone-window-inserts">Window Inserts</a> are placed
		inside your existing window frames to reduce the amount of cold drafts and heat
		loss happening through your windows. This reduces the load on your HVAC and leads
		to lower energy use - saving homeowners an average of 20% per year on energy expenses!
	</p>
	<Image src={archWindowInstallImage} />

	<p class="text-left">
		But the best part? Each Indow Insert is completely custom made for your
		exact window dimensions and shapes. We offer specialty shaped inserts for
		arched windows and trapezoid shaped windows.
	</p>
</Section>

<CustomerStory story={thisOldHouseCustomerStory} />

<Section>
	<h2 class="text-left">More Quiet, More Comfort, More Savings</h2>
	<p class="text-left">
		In addition to a substantial reduction in temperature transfer, Indow
		Inserts also provide significant noise reduction, keeping your home up to
		50%-70% quieter. It's a win-win-win for your pocket book, the planet, and
		your day-to-day comfort.
	</p>
	<p class="text-left">
		Our air-tight seal not only keeps noise out and your ideal temperature in,
		but it also <a href="/solutions/prevent-window-condensation"
			>reduces condensation</a
		>
		and
		<a href="/solutions/block-pollen-and-pollutants"
			>blocks dust, pollen, and other airborne particles</a
		>. But that doesn't mean you'll have to live in a hermetically sealed home!
		With a gentle tug on the provided D-ring, you can break the seal and remove
		the inserts whenever you want to open your windows and let in some fresh
		air.
	</p>
</Section>

<ProductRecommendation product={ThermalProduct} />

<Section backgroundColor="grey-light">
	<h3 class="text-indow-grey-dark">Indow vs Replacement Windows</h3>
	<p>
		Adding Indow inserts to an existing window can make your windows perform as
		well (or better!) than a replacement window, but at a fraction of the cost
		and without the hassle and disruption of installing new windows.
	</p>
	<ChartEnergyEfficiency />
</Section>

<TrustedChoice />
<Reviews />
<GetAFreeEstimate />
